import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

export const MarkdownWrapper = ({ markdown }: { markdown: string | null | undefined }) => {
  return (
    <section className="[&>div:has(table)]:overflow-x-auto [&_p]:text-[16px] [&_p]:leading-[24px] [&_table]:w-full [&_table]:min-w-[600px] [&_table]:border-collapse [&_table_td]:p-[16px] [&_table_td]:[border:1px_solid] [&_table_th]:p-[16px] [&_table_th]:[border:1px_solid] [&_table_tr]:[border:1px_solid]">
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          table: ({ children }) => (
            <div className="mb-4 overflow-x-auto">
              <table className="w-full min-w-[600px]">{children}</table>
            </div>
          ),
        }}
      >
        {markdown}
      </Markdown>
    </section>
  )
}
